import React from 'react';
import Cell from './Cell';
import { StageType } from '../types';

interface StageProps {
  stage: StageType;
}

const Stage: React.FC<StageProps> = ({ stage }) => (
  <div className="stage">
    {stage.map((row, y) => row.map((cell, x) => <Cell key={`${y}-${x}`} type={cell[0]} />))}
  </div>
);

export default Stage;